import { config } from '../../config/config';
import { HttpServices } from '../../Helper';

export const GetSystemReportsResultClientsSegmentation = async (pageIndex, pageSize, body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/SystemReport/GetSystemReportsResult?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
